module.exports = __webpack_public_path__ + "static/img/warning-toast.7cbc8d16.svg";